<div class="tenant-call-config" [testId]="'tenant-call-config-container'">
  <nz-spin [nzSpinning]="loading" [testId]="'tenant-call-config-spin'">
    <section class="tenant-call-config-surface" [testId]="'tenant-call-config-settings-surface'">
      <header class="tenant-call-config-header">
        <div class="tenant-call-config-heading">
          <h3>{{ 'tenant.detail.call-config.title' | i18n }}</h3>
          <p>{{ 'tenant.detail.call-config.description' | i18n }}</p>
        </div>
        <nz-tag
          class="tenant-call-config-sync-tag"
          [nzColor]="getSyncStatusColor(callConfig?.syncStatus)"
          [testId]="'tenant-call-config-sync-status'"
        >
          {{ syncStatusKey | i18n }}
        </nz-tag>
      </header>

      <form [formGroup]="callConfigForm" class="tenant-call-config-form">
        <div class="tenant-call-config-setting">
          <div class="tenant-call-config-setting-copy">
            <div class="tenant-call-config-setting-title">
              <nz-icon nzType="phone" nzTheme="outline" />
              <span>{{ 'tenant.detail.call-config.enable-call.title' | i18n }}</span>
            </div>
            <p>{{ 'tenant.detail.call-config.enable-call.description' | i18n }}</p>
          </div>
          <nz-switch formControlName="enableCall" [testId]="'tenant-call-config-enable-call-switch'" />
        </div>

        <div class="tenant-call-config-setting">
          <div class="tenant-call-config-setting-copy">
            <div class="tenant-call-config-setting-title">
              <nz-icon nzType="audio" nzTheme="outline" />
              <span>{{ 'tenant.detail.call-config.enable-recording.title' | i18n }}</span>
            </div>
            <p>{{ 'tenant.detail.call-config.enable-recording.description' | i18n }}</p>
          </div>
          <nz-switch formControlName="enableRecording" [testId]="'tenant-call-config-enable-recording-switch'" />
        </div>

        <div class="tenant-call-config-setting">
          <div class="tenant-call-config-setting-copy">
            <div class="tenant-call-config-setting-title">
              <nz-icon nzType="customer-service" nzTheme="outline" />
              <span>{{ 'tenant.detail.call-config.auto-recording.title' | i18n }}</span>
            </div>
            <p>{{ 'tenant.detail.call-config.auto-recording.description' | i18n }}</p>
          </div>
          <nz-switch formControlName="enableServiceCallAutoRecording" [testId]="'tenant-call-config-auto-recording-switch'" />
        </div>
      </form>

      <footer class="tenant-call-config-actions">
        <span>{{ 'tenant.detail.call-config.save-hint' | i18n }}</span>
        <div>
          <button nz-button nzType="default" (click)="resetCallConfig()" [testId]="'tenant-call-config-reset-button'">
            {{ 'common.reset' | i18n }}
          </button>
          <button nz-button nzType="primary" [nzLoading]="saving" (click)="saveCallConfig()" [testId]="'tenant-call-config-save-button'">
            {{ 'common.save' | i18n }}
          </button>
        </div>
      </footer>
    </section>
  </nz-spin>
</div>
